import { observable, transaction } from 'mobx';
import type { IBaseModel } from '@src/slide/domain/ui-model/element-modeles/Interface/base/base-model.interface';

export interface IConnectingInfo {
    model: IBaseModel | { id?: string };
    endIndex: number;
    isOnElement?: boolean;
}

export default class EditingStateManager {
    @observable
    public isResizing = false;
    @observable
    public isTableRowColResizing = false; // 表格行列调整
    public resizeMode: any = null;
    @observable
    public isDragging = false;
    @observable
    public isDraggingElement = false;
    @observable
    public isRotating = false;
    @observable
    public isCroping = false;
    @observable
    public isConnecting = false;
    @observable
    public readyToConnect = false;
    @observable
    public connectingInfo: IConnectingInfo | null = null;
    /**
     * 通过方向键触发形状移动
     */
    @observable
    public isMovingWithKeyUpDown = false;
    /**
     * 是否进入了某个编辑区域
     */
    @observable
    public isEditing = false;
    public keyFlag4Moving = 0;
    /**
     * 图形控制点是否正在变更
     */
    @observable
    public isControlValuesChanging = false;

    /**
     * 正在鼠标插入的图形
     */
    @observable
    public insertState: any = {
        type: null,
        data: null,
    };

    /**
     * 是否需要阻止掉 iframe 元素的事件，加这个是因为在 iframe 元素上面不会触发外层对应的鼠标事件
     * 具体见 demo：https://codepen.io/zengkan0703/pen/KKQzPyN
     */
    @observable
    public needDisableIframeEvent = false;

    /**
     * 标志当前文档是否有编辑了但是未保存的文字变更
     */
    @observable
    public hasUnsavedTextContent = false;

    public isInAnyEditingState(): boolean {
        return this.isResizing || this.isDragging || this.isCroping || this.isRotating;
    }

    public clearInsertState(): void {
        this.insertState = {
            type: null,
            data: null,
        };
    }

    public updateElementDraggingState(isDraggingElement: boolean): void {
        transaction(() => {
            this.isDragging = isDraggingElement;
            this.isDraggingElement = isDraggingElement;
        });
    }

    public updateElementRotateState(isRotatingElement: boolean): void {
        transaction(() => {
            this.isRotating = isRotatingElement;
        });
    }

    public updateElementResizeState(isResizingElement: boolean, mode?: string): void {
        transaction(() => {
            this.isResizing = isResizingElement;
            this.resizeMode = mode;
        });
    }

    public updateElementCropState(isCroping: boolean): void {
        transaction(() => {
            this.isCroping = isCroping;
        });
    }

    public updateTableRowColResizeState(isResizingElement: boolean): void {
        transaction(() => {
            this.isTableRowColResizing = isResizingElement;
        });
    }
}
